import store from "@/store";
import { guardSystemSettingsRoute } from "@/utils/systemSettingsAccess";

const systemSettingsGuard = (to, from, next) => guardSystemSettingsRoute(to, from, next, store);

const routes = [
  {
    path: "/system-settings/notifications/:id",
    name: "notifications",
    component: () => import("@/views/main/SystemSettings/NotificationSettings.vue"),
    beforeEnter: systemSettingsGuard,
    meta: { requiresAuth: true, title: "Notifications" },
  },
  {
    path: "/my-reminders",
    name: "my-reminders",
    component: () => import("@/views/main/modules/MyReminders.vue"),
    meta: { requiresAuth: true, title: "My Reminders" },
  },
  {
    path: "/my-profile",
    name: "my-profile",
    component: () => import("@/views/main/modules/MyProfile.vue"),
    meta: { requiresAuth: true, title: "My Profile" },
  },
  {
    path: "/system-settings/navigation-drawer/:id",
    name: "navigationdrawer",
    component: () => import("@/views/main/SystemSettings/NavigationDrawer.vue"),
    beforeEnter: systemSettingsGuard,
    meta: {
      requiresAuth: true,
      title: "Navigation Settings",
    },
  },
  {
    path: "/system-settings/general-settings/:id",
    name: "generalsettings",
    component: () => import("@/views/main/SystemSettings/GeneralSettingsComponent.vue"),
    beforeEnter: systemSettingsGuard,
    meta: {
      requiresAuth: true,
      title: "General Settings",
    },
  },
  {
    path: "/system-settings/approvers/:id",
    name: "approvers",
    component: () => import("@/views/main/SystemSettings/ApproverSettings.vue"),
    beforeEnter: systemSettingsGuard,
    meta: {
      requiresAuth: true,
      title: "Approvers",
    },
  },
];
export default routes;
